import React from 'react';
import LineChart, { LineChartProps } from '@components/report/chart/line-chart/LineChart';
import TriangleChart, {
	TriangleChartProps,
} from '@components/report/chart/triangle-chart/TriangleChart';
import ReportCard from '@components/report/report-card/ReportCard';
import { threeDivisionGridClass } from '@components/report/style.css';
import { useTranslation } from 'react-i18next';

export interface FollowerGrowthTtProps {
	followerTrend?: LineChartProps;
	followerGrowthRate?: TriangleChartProps;
	followingTrend?: LineChartProps;

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const FollowerGrowthTt = ({
	followerTrend,
	followerGrowthRate,
	followingTrend,

	isLoading,
	isError,
	lackOfPermission,
}: FollowerGrowthTtProps) => {
	const { t } = useTranslation('infReportTiktok');
	const status = { isLoading, isError, lackOfPermission };
	return (
		<div className={threeDivisionGridClass}>
			<ReportCard
				label={t(
					'features.report.section-content.tt.follower-growth.follower-trend.label',
				)}
				tooltip={t(
					'features.report.section-content.tt.follower-growth.follower-trend.tooltip',
				)}
				lackOfPermission={lackOfPermission}
			>
				<LineChart
					subDesc={t(
						'features.report.section-content.tt.follower-growth.follower-trend.line-chart.sub-description',
					)}
					data_name_a={t(
						'features.report.section-content.tt.follower-growth.follower-trend.line-chart.follower',
					)}
					desc={true}
					{...status}
					{...followerTrend}
				/>
			</ReportCard>

			<ReportCard
				label={t(
					'features.report.section-content.tt.follower-growth.follower-growth-rate.label',
				)}
				tooltip={t(
					'features.report.section-content.tt.follower-growth.follower-growth-rate.tooltip',
				)}
				lackOfPermission={lackOfPermission}
			>
				<TriangleChart desc={true} {...followerGrowthRate} {...status} />
			</ReportCard>

			<ReportCard
				label={t(
					'features.report.section-content.tt.follower-growth.following-trend.label',
				)}
				tooltip={t(
					'features.report.section-content.tt.follower-growth.following-trend.tooltip',
				)}
				lackOfPermission={lackOfPermission}
			>
				<LineChart
					subDesc={t(
						'features.report.section-content.tt.follower-growth.following-trend.line-chart.sub-description',
					)}
					data_name_a={t(
						'features.report.section-content.tt.follower-growth.following-trend.line-chart.following',
					)}
					desc={true}
					{...status}
					{...followingTrend}
				/>
			</ReportCard>
		</div>
	);
};

export default FollowerGrowthTt;
